import { ExternalLink } from 'lucide-react'

import { SplitsLink } from '~/components/Link'
import { List, NetworkDisplay } from '~/components/component-library'
import { SupportedChainId } from '~/constants/chains'
import { useSmartAccount } from '~/hooks/useSmartAccounts'
import { IAddress } from '~/types'
import { sortChainIds } from '~/utils'
import { getExplorerAddressLinkChainId } from '~/utils/addresses'

export const AccountNetworksList = ({ address }: { address: IAddress }) => {
  const { smartAccount } = useSmartAccount(address)

  return (
    <List
      label="Networks"
      items={sortChainIds(smartAccount?.chainIds ?? []).map(
        (chainId: SupportedChainId) => ({
          key: `${chainId}`,
          content: <NetworkDisplay layout="standard" chainId={chainId} />,
          actionIcon: <ExternalLink className="h-4 w-4 text-secondary" />,
          href: {
            path: getExplorerAddressLinkChainId(address, chainId)!,
            target: 'tab',
          },
        }),
      )}
      footer={
        <p>
          Looking for another network? Manage enabled networks in{' '}
          <SplitsLink path="/settings/team/networks" target="tab" underline>
            settings
          </SplitsLink>
          .
        </p>
      }
    />
  )
}
